import { render, staticRenderFns } from "./MatchPlayers.vue?vue&type=template&id=edf44d1c&scoped=true&"
import script from "./MatchPlayers.vue?vue&type=script&lang=js&"
export * from "./MatchPlayers.vue?vue&type=script&lang=js&"
import style0 from "./MatchPlayers.vue?vue&type=style&index=0&id=edf44d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf44d1c",
  null
  
)

export default component.exports